import BrandSubscriptionView from './BrandSubscriptionView';
import { BrandSubscriptionModel } from 'owa-brands-subscription';
import groupSubscriptions, { GroupedSubscriptions } from '../utils/groupSubscriptions';
import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./BrandSubscriptionListView.scss');

export interface BrandSubscriptionListViewProps {
    brandsSubscriptions: BrandSubscriptionModel[];
    isUnsubscribed: boolean;
}

@observer
export default class BrandSubscriptionListView extends React.Component<
    BrandSubscriptionListViewProps,
    {}
> {
    render() {
        if (this.props.brandsSubscriptions.length > 0) {
            return <div className={styles.listView}>{this.renderBrandsSubscriptionsViews()}</div>;
        }

        return null;
    }

    private renderBrandsSubscriptionsViews = (): JSX.Element[] => {
        const groupedSubscriptions: GroupedSubscriptions = groupSubscriptions(
            this.props.brandsSubscriptions
        );

        const views: JSX.Element[] = groupedSubscriptions.orderedIds.map(id => {
            if (id in groupedSubscriptions.brandSubscriptions) {
                return (
                    <BrandSubscriptionView
                        brandSubscriptions={groupedSubscriptions.brandSubscriptions[id]}
                        isUnsubscribed={this.props.isUnsubscribed}
                        key={id}
                    />
                );
            } else {
                return (
                    <BrandSubscriptionView
                        brandSubscriptions={groupedSubscriptions.subscriptions[id]}
                        isUnsubscribed={this.props.isUnsubscribed}
                        key={id}
                    />
                );
            }
        });
        return views;
    };
}
